import {
	productStatus,
	linkStatus,
	promoteStatus,
	cooperationStatus,
	deliveryStatus,
	refuseDelivery,
	affirmStatus,
	changeStatus,
	sampleStutas,
} from '@/utils/dataMap';
export const getButtons = (that, item) => {
	const arr = [];
	const isKsPlatform = that.$isKs(item.platform_id);
	const checkLinkText = isKsPlatform ? '校验商品机制' : '校验链接';
	const refuseDeliverStatus = 400;
	// 合作进度已暂停
	const isPauseCooperate = +item.cooperate_status === +cooperationStatus.pause;
	// 商品是否已下架
	const isProductTakedOff = +item.product_status === +productStatus.down;
	// 商品是否已停止推广
	const isPromoteClose = +item.promote_status == +promoteStatus.close;
	// 物流未发货
	const hasNotDeliver = +item.delivery_status === +deliveryStatus.notShipped;
	// 物流是否已到货
	const isDeliverArrived = +item.delivery_status == +deliveryStatus.arrived;
	// 是否拒绝发货
	const isRefuseDelivery = +item.is_refuse_delivery == +refuseDelivery.yes;
	// 链接校验状态为待校验链接
	const isUrlWaitCheck = +item.url_check_status === +linkStatus.tobeCheck;
	// 商品机制是否改变
	const isGoodsChange = +item.is_change == +changeStatus.yes;
	// 是否拒绝带货
	const isRefuseSellGoods = +item.is_affirm == +affirmStatus.refuse;
	//审核不通过
	const noPass = +item.order_other_status === +sampleStutas.noPass;

	//选品表
	if (that.isSelectionTable) {
		const modifyGoods = {
			label: '修改商品机制',
			type: 'text',
			isShow: !isProductTakedOff && !isPromoteClose && that.$auth.hasPermi('system:cooperationProgress:edit-goods'),
			classtype: 2,
			click: (row, tabName) => that.editProductFun(row, tabName),
		};
		const applySample = {
			label: '申请样品',
			type: 'text',
			// isShow: !isGoodsChange && isProductOnline && !isPromoteClose,
			isShow: !isGoodsChange && that.$auth.hasPermi('system:cooperationProgress:selection:Apply'),
			classtype: 2,
			click: (row, tabName) => that.applyFun(row, tabName),
		};
		const noSampleStartLive = {
			label: '无样开播',
			type: 'text',
			isShow: !isGoodsChange && that.$auth.hasPermi('system:cooperationProgress:selection:nullify'),
			classtype: 2,
			click: (row, tabName) => that.beginFun(row, 3, tabName),
		};
		const delFromSelectionTable = {
			label: '移除选品表',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:selection:Remove'),
			classtype: 2,
			click: (row, tabName) => that.multiFun(row, 2, tabName, item.platform_id),
		};
		const viewGoodsChangeDetail = {
			label: '查看变更详情',
			type: 'text',
			isShow: isGoodsChange && that.$auth.hasPermi('system:cooperationProgress:change-Details'),
			classtype: 2,
			click: (row, tabName) => that.changeDFun(row, tabName),
		};
		arr.push(modifyGoods, viewGoodsChangeDetail, applySample, noSampleStartLive, delFromSelectionTable);
	}
	//申样表
	if (that.isSampleTable) {
		const refuseSellGoodsReason = {
			label: '拒绝带货原因',
			type: 'text',
			isShow: isRefuseSellGoods && that.$auth.hasPermi('system:sampleOrder:refusingTakeGoods'),
			classtype: 2,
			click: (row, tabName) => that.reasonFun(row, '1', tabName),
		};
		const refuseDeliverReason = {
			label: '拒绝发货原因',
			type: 'text',
			isShow: isRefuseDelivery && that.$auth.hasPermi('system:sampleOrder:reasons-refusing-goods'),
			classtype: 2,
			click: (row, tabName) => that.reasonFun(row, '1', tabName),
		};
		const modifyGoods = {
			label: '修改商品机制',
			type: 'text',
			isShow: !isProductTakedOff && !isPromoteClose && that.$auth.hasPermi('system:sampleOrder:Commodity-mechanism'),
			classtype: 2,
			click: (row, tabName) => that.editProductFun(row, tabName),
		};
		const delGoods = {
			label: '移除商品',
			type: 'text',
			isShow:
				(isProductTakedOff || isPromoteClose || isRefuseSellGoods || isRefuseDelivery || noPass) &&
				that.$auth.hasPermi('system:sampleOrder:ClosedSample'),
			classtype: 2,
			click: (row, tabName) => that.multiFun({ ...row, sampleOrder: that.sampleOrder }, 8, tabName, item.platform_id),
		};
		const reissueSample = {
			label: '补寄样品申请',
			tips: item?.cooperate_partner_info?.audit_role === 'rd' ? '与热度星选协同的合作进度不支持补寄样品' : '',
			disabled: item?.cooperate_partner_info?.audit_role === 'rd',
			type: 'text',
			isShow:
				!hasNotDeliver &&
				item.other_status !== refuseDeliverStatus &&
				that.cooperation &&
				that.$auth.hasPermi('system:cooperationProgress:SupplementarSample'),
			classtype: 2,
			click: that.showReissueDrawer,
		};
		const changeLId = {
			label: '更换ID',
			type: 'text',
			isShow: isKsPlatform && !isPauseCooperate && that.$auth.hasPermi('system:sampleOder:switchLink'),
			classtype: 2,
			click: (row, tabName) => that.replaceLinkFun(row, tabName, '更换ID'),
		};
		const confirmSellGoods = {
			label: '确认带货',
			type: 'text',
			// isShow: !isProductTakedOff && isPromoteOpen && isDeliverArrived && !isRefuseSellGoods,
			isShow: isDeliverArrived && !isRefuseSellGoods && that.$auth.hasPermi('system:sampleOrder:Confirm-shipmentation'),
			classtype: 2,
			click: (row, tabName) => that.beginFun(row, 2, tabName),
		};
		const refuseSellGoods = {
			label: '拒绝带货',
			type: 'text',
			// isShow: isProductOnline && isPromoteOpen && isDeliverArrived && !isRefuseSellGoods,
			isShow: isDeliverArrived && !isRefuseSellGoods && that.$auth.hasPermi('system:sampleOrder:RefuseTakeGoods'),
			classtype: 2,
			click: row => that.refuseFun(row),
		};
		const viewGoodsChangeDetail = {
			label: '查看变更详情',
			type: 'text',
			isShow: isGoodsChange && that.$auth.hasPermi('system:cooperationProgress:change-Details'),
			classtype: 2,
			click: (row, tabName) => that.changeDFun(row, tabName),
		};
		arr.push(
			refuseSellGoodsReason,
			refuseDeliverReason,
			modifyGoods,
			delGoods,
			reissueSample,
			changeLId,
			confirmSellGoods,
			refuseSellGoods,
			viewGoodsChangeDetail,
		);
	}
	//待播表
	if (that.isWaitLiveTable) {
		const isUrlCompleteCheck = item.url_check_status === linkStatus.finished;
		const reissueSample = {
			label: '补寄样品申请',
			tips: item?.delivery_audit_info?.audit_role === 'rd' ? '与热度星选协同的合作进度不支持补寄样品' : '',
			disabled: item?.delivery_audit_info?.audit_role === 'rd',
			type: 'text',
			isShow: !isPauseCooperate && that.cooperation && that.$auth.hasPermi('system:cooperationProgress:SupplementarSample'),
			classtype: 2,
			click: that.showReissueDrawer,
		};
		const starSchedule = {
			label: '更新达人档期',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:Waiting:authorSchedule'),
			classtype: 2,
			click: row => that.handleStarScheduleShow(row),
		};
		const continueOrEndCooperate = {
			label: isPauseCooperate ? '继续合作' : '停止合作',
			type: 'text',
			isShow: true,
			classtype: 2,
			click: isPauseCooperate ? that.reCooperation : that.stopCooperation,
		};
		const delGoodsOld = {
			label: '移除商品',
			type: 'text',
			isShow: !isPauseCooperate && (isProductTakedOff || isPromoteClose) && that.$auth.hasPermi('system:cooperationProgess:Waiting-del-goods'),
			classtype: 2,
			click: (row, tabName) => that.multiFun(row, 1, tabName, item.platform_id),
		};
		const delGoods = {
			label: '移除商品',
			type: 'text',
			isShow: isPauseCooperate && that.$auth.hasPermi('system:cooperationProgess:Waiting-del-goods'),
			classtype: 2,
			click: that.delCooperation,
		};
		const checkLink = {
			label: checkLinkText,
			type: 'text',
			isShow: isUrlWaitCheck && !isPauseCooperate && that.$auth.hasPermi('system:cooperationProgress:Waiting-verify'),
			classtype: 2,
			click: (row, tabName) => that.multiFun(row, 4, tabName, item.platform_id),
		};
		const confirmStartLive = {
			label: '确认开播',
			type: 'text',
			isShow:
				isUrlCompleteCheck &&
				!item?.delivery_audit_info?.audit_status_desc &&
				!isPauseCooperate &&
				that.$auth.hasPermi('system:cooperationProgress:Confirmed-broadcasting'),
			classtype: 2,
			click: (row, tabName) => that.beginFun(row, 1, tabName),
		};
		const check = {
			label: '审核',
			type: 'text',
			tips: item?.delivery_audit_info?.audit_role === 'rd' ? '与热度星选协同的合作进度由热度星选审核' : '',
			disabled: item?.delivery_audit_info?.audit_role === 'rd',
			isShow: that.$auth.hasPermi('system:cooperationProgress:check') && +item?.delivery_audit_info?.audit_status === 0,
			classtype: 2,
			click: (row, tabName) => that.deliverFun(row, 1, tabName),
		};

		const reviewCheck = {
			label: '查看交付内容',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:review-check') && item?.delivery_audit_info?.audit_status_desc,
			classtype: 2,
			click: (row, tabName) => that.deliverFun(row, 2, tabName),
		};
		const rejectReason = {
			label: '查看拒绝原因',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:reject-reason') && +item?.delivery_audit_info?.audit_status === 20,
			classtype: 2,
			click: (row, tabName) => that.deliverFun(row, 3, tabName),
		};
		const reStartLive = {
			label: '重新提交',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:restart-live') && +item?.delivery_audit_info?.audit_status === 20,
			classtype: 2,
			click: (row, tabName) => that.beginFun(row, 4, tabName),
		};
		arr.push(
			reissueSample,
			starSchedule,
			checkLink,
			confirmStartLive,
			continueOrEndCooperate,
			delGoods,
			delGoodsOld,
			check,
			reviewCheck,
			rejectReason,
			reStartLive,
		);
	}
	//开播表
	if (that.isStartLiveTable) {
		// 合作进度未停止
		const isCooperateNotEnd = item.cooperate_status !== cooperationStatus.end;
		const viewVideoEffect = {
			label: '查看交付内容',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:broadcast-video'),
			classtype: 2,
			click: row => that.lookVide(row),
		};

		const endCooperate = {
			label: '结束合作',
			type: 'text',
			isShow: isCooperateNotEnd && that.$auth.hasPermi('system:cooperationProgress:broadcast-finish'),
			classtype: 2,
			click: (row, tabName) => that.multiFun(row, 6, tabName, item.platform_id),
		};
		const reissueSample = {
			label: '补寄样品申请',
			tips: item?.delivery_audit_info?.audit_role === 'rd' ? '与热度星选协同的合作进度不支持补寄样品' : '',
			disabled: item?.delivery_audit_info?.audit_role === 'rd',
			type: 'text',
			isShow: isCooperateNotEnd && that.$auth.hasPermi('system:cooperationProgress:SupplementarSample'),
			classtype: 2,
			click: that.showReissueDrawer,
		};
		const starSchedule = {
			label: '更新达人档期',
			type: 'text',
			isShow: that.$auth.hasPermi('system:cooperationProgress:broadcast:authorSchedul'),
			classtype: 2,
			click: row => that.handleStarScheduleShow(row),
		};
		const viewSampleOrder = {
			label: '查看关联样品',
			type: 'text',
			isShow: that.$auth.hasPermi('system:sampleOrder-query'),
			classtype: 2,
			click: (row, tabName) => that.viewSampleOrder(row, 6, tabName),
		};
		const changeLId = {
			label: '更换ID',
			type: 'text',
			isShow: isKsPlatform && !isPauseCooperate && that.$auth.hasPermi('system:cooperationProgress:broadcast-changeLink'),
			classtype: 2,
			click: (row, tabName) => that.replaceLinkFun(row, tabName, '更换ID'),
		};
		arr.push(endCooperate, reissueSample, starSchedule, viewSampleOrder, viewVideoEffect, changeLId);
	}

	//通用
	arr.push(
		{
			label: '查看手卡',
			type: 'text',
			isShow: item.hand_card,
			classtype: 2,
			click: that.lookCard,
		},
		{
			label: '查看详情',
			type: 'text',
			isShow: true,
			classtype: 2,
			click: (row, tabName) => that.detailsFun(row, tabName),
		},
	);
	let filterArr = arr.filter(item => item.isShow);
	return filterArr;
};
